import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import {
  BehaviorSubject,
  Observable,
  observable,
  of,
  Subscription,
} from 'rxjs';
import { JobStatusCount } from '../../../../jobs/models/job-status-count';
import { MyJobStatuses } from '../../../../jobs/models/job-statuses';
import { JobSummary } from '../../../../jobs/models/job-summary';
import { JobsStore } from '../../../../jobs/store/jobs-store.service';

@Component({
  selector: 'app-dashboard-candidate-summary',
  templateUrl: './dashboard-summary.component.html',
  styleUrls: ['./dashboard-summary.component.scss'],
})
export class DashboardCandidateSummaryComponent implements OnInit {

  public title: string = "";
  public jobs: JobSummary[] = [];
  selectedStatus: string;
  _pageCount = new BehaviorSubject<number>(0);
  public pageCount: Observable<number> = this._pageCount.asObservable();
  public jobStatusCounts: JobStatusCount = new JobStatusCount();

  constructor(
    private jobsStore: JobsStore,
    private activatedRoute: ActivatedRoute
  ) {
    this.title = this.jobsStore.PROPOSED_JOB_TITLE;
  }

  ngOnInit() {
    this.jobsStore.jobStatusCounts.subscribe((statusCount) => {
      if (!statusCount) {
        return;
      }

      this.jobStatusCounts.appliedJobs = statusCount.appliedJobs;
      this.jobStatusCounts.savedJobs = statusCount.savedJobs;
      this.jobStatusCounts.invitedJobs = statusCount.invitedJobs;
      this.jobStatusCounts.inProgressJobs = statusCount.inProgressJobs;
      this.jobStatusCounts.finishedJobs = statusCount.finishedJobs;
    });

    this.jobsStore.getMyJobsStatusCount();

    this.activatedRoute.data.subscribe((jobResult) => {
      this.selectedStatus = 'appliedJobs';
      this._pageCount.next(jobResult.jobs.pageCount);
      jobResult.jobs.result.forEach((x) => {
        this.jobs.push(x);
      });
    });
  }

  pageNumberClicked(pageNumber: number): void {
    this.loadMyJobs(this.selectedStatus, pageNumber);
  }

  onJobStatusClicked(status: string): void {
    this.loadMyJobs(status, 1);
  }

  loadMyJobs(status: string, pageNumber: number): void {
    this.jobs = [];
    this.pageCount = this._pageCount.asObservable();
    this.selectedStatus = status;
    switch (this.selectedStatus) {
      case 'appliedJobs': {
        this.jobsStore
          .getMyJobs(MyJobStatuses.Applied, pageNumber)
          .then((jobResult) => {
            this._pageCount.next(jobResult.pageCount);
            jobResult.result.forEach((x) => {
              this.jobs.push(x);
            });

            this.title = this.jobsStore.PROPOSED_JOB_TITLE;
          });
        break;
      }
      case 'savedJobs': {
        this.jobsStore
          .getMyJobs(MyJobStatuses.Saved, pageNumber)
          .then((jobResult) => {
            this._pageCount.next(jobResult.pageCount);
            jobResult.result.forEach((x) => {
              this.jobs.push(x);
            });

            this.title = 'Saved Jobs';
          });
        break;
      }
      case 'jobInvites': {
        this.jobsStore
          .getMyJobs(MyJobStatuses.Invite, pageNumber)
          .then((jobResult) => {
            this._pageCount.next(jobResult.pageCount);
            jobResult.result.forEach((x) => {
              this.jobs.push(x);
            });

            this.title = 'Job Invites';
          });
        break;
      }
      case 'inProgressJobs': {
        this.jobsStore
          .getMyJobs(MyJobStatuses.InProgress, pageNumber)
          .then((jobResult) => {
            this._pageCount.next(jobResult.pageCount);
            jobResult.result.forEach((x) => {
              this.jobs.push(x);
            });

            this.title = 'In Progress Jobs';
          });
        break;
      }
      case 'finishedJobs': {
        this.jobsStore
          .getMyJobs(MyJobStatuses.Finished, pageNumber)
          .then((jobResult) => {
            this._pageCount.next(jobResult.pageCount);
            jobResult.result.forEach((x) => {
              this.jobs.push(x);
            });

            this.title = 'Finished Jobs';
          });
        break;
      }
    }
  }
}
